import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import FeedbackPage from "./components/FeedbackPage";
import { Toaster } from "./components/ui/sonner";

const root = ReactDOM.createRoot(document.getElementById("root"));

const path = window.location.pathname;
const isFeedback = path.startsWith("/feedback/");

root.render(
  <React.StrictMode>
    {isFeedback ? (
      <>
        <Toaster position="top-right" />
        <FeedbackPage reservationId={path.replace(/^\/feedback\//, "").replace(/\/$/, "")} />
      </>
    ) : (
      <App />
    )}
  </React.StrictMode>,
);
